import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import tag from '@/assets/tag.png';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/Elements/Button';
import { Modal } from 'react-responsive-modal';
import { getFeaturePlans } from '@/api/feature/getFeatures';
import { Feature } from '@/types';

export type ConfirmationDialogProps = {
  propType: string;
  propId: string;
  show: boolean;
  setShow: (i: boolean) => void;
};

export const FeatureAdd = ({ propType, propId, show, setShow }: ConfirmationDialogProps) => {
  const navigate = useNavigate();

  const [plans, setPlan] = React.useState([]);
  const [err, setErr] = React.useState<boolean>(false);
  const [value, setValue] = React.useState('');
  const [price, setPrice] = React.useState('');

  const onHideModal = () => {
    setShow(false);
    setErr(false);
  };

  React.useEffect(() => {
    const getPlans = async () => {
      const data: any = await getFeaturePlans();
      setPlan(data?.all_data);
    };
    getPlans();
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = (event.target as HTMLInputElement).value;
    setValue(selectedValue);
    const selectedPlan: any = plans?.find((plan: Feature) => plan.id == selectedValue);
    setPrice(selectedPlan?.price || '');
    setErr(false);
  };

  return (
    <>
      <Modal className="select-plan-model" open={show} onClose={onHideModal} center>
        <section className="model-datas feature-modal text-center">
          <img src={tag} className="m-auto tag-icon" />
          <h3 className="text-center text-dark f-20 mt-3 font-semibold">Select plan</h3>
          <p className="text-dark text-center f-14 mb-4">Simple and flexible per-user pricing.</p>
          <div className="applicable-tct">Upgrade your property to a top position</div>
          <div className="feature-ad d-flex justify-between items-center">
            <h4 className="font-semibold text-dark f-20">Feature Ad</h4>
            {/* <Button variant="outline" className="f-13" size="sm">
                See More
              </Button> */}
          </div>
          <p className="f-13 d-flex gap-2 items-center  text-dark">
            <i className="fa-solid fa-circle-check pink f-14"></i>Get Noticed with 'FEATURED' tag in
            a top position{' '}
          </p>
          <p className="f-13 d-flex items-center  gap-2 text-dark">
            <i className="fa-solid fa-circle-check pink f-14"></i>Ad will be highlighted to top
            positions{' '}
          </p>
          {/* <p className="f-13 d-flex items-center  gap-2 text-dark">
              <i className="fa-solid fa-circle-check pink f-14"></i>Reach more buyers and sell
              faster
            </p> */}
          <div className="feature-box">
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              {plans?.map((plan: any) => {
                return (
                  <div className="features-max py-2">
                    <div className="d-flex justify-between items-center">
                      <FormControlLabel value={plan?.id} control={<Radio />} label={plan?.name} />
                      <p className="text-dark font-semibold f-14">${plan?.price}</p>
                    </div>
                    <p className="f-13 d-flex items-center gap-2">
                      <i className="fa-solid fa-check"></i>
                      {plan?.benfits}
                    </p>
                  </div>
                );
              })}
              {err && <span className="text-danger">Please select the plan</span>}
            </RadioGroup>
          </div>
        </section>
        <p className="btn-lines delete-bots gap-1 d-flex justify-content-center">
          <Button variant="outline" className="rounded-full" onClick={onHideModal}>
            Cancel
          </Button>
          <Button
            className="rounded-full pink-btn"
            onClick={() => {
              if (!value) {
                return setErr(true);
              }
              navigate(
                `/user/subscription-select-payment/${value}?price=${price}&propType=${propType}&propId=${propId}`
              );
            }}
          >
            Confirm
          </Button>
        </p>
      </Modal>
    </>
  );
};
